// extracted by css-extract-rspack-plugin
export default {"StripeDefs":"StripeDefs--FT86u"};